import React, { useState, useEffect } from 'react'

import Loader from '../../../../../presentationals/Loader/Loader.component';
import NodataImage from '../../../../../../images/nodata.png';
import { getOEMBatteryDetails } from '../ActionCreator';
import Pagination from '../../utils/TablePagination'
import { paginationFuction } from '../../utils/commonFunction';
import moment from 'moment';

const itemsPerPage = 10;
export default function OEMtable({ handleTab }) {
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([]);
    const [data, setData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);

    useEffect(() => {
        getOEMBatteryDetailsFunction()
    }, [])

    const getOEMBatteryDetailsFunction = () => {
        setLoader(true)
        getOEMBatteryDetails((callback) => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.message == "success" && callback?.status == 200 && callback?.data?.length > 0) {
                settableData(callback?.data)
                updatePageData(callback.data, 1);
            } else {
                settableData([])
                setData([])
            }
        })
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        updatePageData(tableData, value);
    }

    const updatePageData = (datas, page) => {

        const indexOfLastItem = (page) * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = datas && datas?.length > 0 ? datas?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setData(currentItems)
    };

    const paginationHandlerNew = (type, pageNumber) => {
        paginationFuction(type, pageNumber, tableData?.length, callBack => {
            console.log(callBack, 'callback')
            setcurrentPage(callBack)
            updatePageData(tableData, callBack)
        })
    }

    const getDatefn = (timestamp)=>{
        if(timestamp == "" || timestamp == undefined || timestamp == null){
            return "-"
        }else{

            const date = new Date(timestamp);
            const day = String(date.getDate()).padStart(2, '0');     
            const month = String(date.getMonth() + 1).padStart(2, '0'); 
            const year = date.getFullYear();
            
            return `${day}-${month}-${year}`;
        }
    }


    return (
        <>
            <div className="communitySection">
                <div className='container-fluid' style={{ marginTop: '20px' }}>
                    {
                        loader ?
                            <Loader />
                            : ''}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0px 0 30px 0' }}>
                        <h3>Battery OEM</h3>
                        <button
                            className='cred-btn'
                            onClick={e => handleTab('addEdit')}
                            style={{ padding: '14px 15px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-plus' /></button>

                    </div>
                    {
                        data && data?.length > 0 ?
                            <div className='table-responsive full-height'>
                                <div className="">
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='table credhub-table' style={{ boxShadow: '0 1px 2px 0 rgba(60, 64, 67, 0.302), 0 1px 3px 1px rgba(60, 64, 67, 0.149)' }}>
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="text-center">OEM Id</th>
                                                    <th scope="col" className="text-center">OEM Name</th>
                                                    <th scope="col" className="text-center">Weightage</th>
                                                    <th scope="col" className="text-center">Product Code</th>
                                                    <th scope="col" className="text-center">Brand</th>
                                                    <th scope="col" className="text-center">Model Name</th>
                                                    <th scope="col" className="text-center">Capacity(Ah)</th>
                                                    <th scope="col" className="text-center">Voltage(V)</th>
                                                    <th scope="col" className="text-center">Battery Type</th>
                                                    <th scope="col" className="text-center">Warranty(in Months)</th>
                                                    <th scope="col" className="text-center">IOT</th>
                                                    <th scope="col" className="text-center">Charger</th>
                                                    <th scope="col" className="text-center">Price</th>
                                                    <th scope="col" className="text-center">Manufacture Date</th>
                                                    <th scope="col" className="text-center">Expiry Date</th>
                                                    <th scope="col" className="text-center">Added On</th>
                                                    
                                                    <th scope="col" className="text-center">Edit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((data, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.batteryOemId || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.oemName || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.weightage || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.productCode || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.brand || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.modelName || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.capacityAh || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.voltageV || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.batteryType || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.warrantyMonths || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.iot || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.charger || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{data?.price || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{getDatefn(data?.manufactureDate) || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{getDatefn(data?.expiryDate) || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>{getDatefn(data?.addedOn) || "-"}</td>
                                                            <td className="text-center" style={{ background: '#fff', border: "1px solid #eee" }}>
                                                                <button className='btn action-btn' onClick={e => handleTab('addEdit', data)}>
                                                                    <i className='fa fa-edit' />
                                                                </button>
                                                            </td>


                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div style={{ float: 'right', marginTop: '20px' }}>
                                    <Pagination
                                        count={Math.ceil(tableData?.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </div> */}
                                    <Pagination

                                        paginationHandlerNew={paginationHandlerNew}
                                        totalCount={tableData?.length}
                                        pageNumber={currentPage}
                                        noOfRows={itemsPerPage}
                                    />
                                </div>
                            </div>
                            :
                            <p style={{ marginTop: '100px' }} className="text-center">
                                <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                            </p>
                    }

                </div>
            </div>
        </>
    )
}
